const ReportEndpoint = {
  RENDER: '/cmms/pdf-render/render',
  PREFILL: '/default/token/prefill',
  GET_AVAILABLE_TOKEN_GROUPS: '/default/token/get-available-token-groups',
};

export default ReportEndpoint;
